<template>
  <img
    :class="type === 'topVisual' ? 'slide' : 'imageContainer'"
    :src="image"
    :alt="type"
  />
</template>

<script>
import AnswerPageUrl from '~/assets/images/answer_page.png'
import EditPageUrl from '~/assets/images/edit_page.png'
import JoinPageUrl from '~/assets/images/join_page.png'
import Participant1Url from '~/assets/images/participant_p1.png'
import Participant2Url from '~/assets/images/participant_p2.png'
import PresentationAnswerPageUrl from '~/assets/images/presentation_answer_page.png'
import PresentationQuiz1Url from '~/assets/images/presentation_q1.png'
import PresentationQuiz2Url from '~/assets/images/presentation_q2.png'
import PresentationQuiz3Url from '~/assets/images/presentation_q3.png'
import PresentationQuiz4Url from '~/assets/images/presentation_q4.png'
import TopVisualUrl from '~/assets/images/top_visual.jpg'

const images = {
  topVisual: TopVisualUrl,
  header: TopVisualUrl,
  answerPage: AnswerPageUrl,
  editPage: EditPageUrl,
  joinPage: JoinPageUrl,
  presentationAnswerPage: PresentationAnswerPageUrl,
  quiz1: PresentationQuiz1Url,
  quiz2: PresentationQuiz2Url,
  quiz3: PresentationQuiz3Url,
  quiz4: PresentationQuiz4Url,
  participant1: Participant1Url,
  participant2: Participant2Url
}

export default {
  props: {
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    image() {
      return images[this.type]
    }
  }
}
</script>

<style lang="scss" scoped>
.imageContainer {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.slide {
  overflow: hidden;
  min-width: 100%;
  min-height: 750px;
  opacity: 0.7;

  object-fit: cover;
  @media screen and (max-width: ($mobile)) {
    height: 100%;
    object-fit: scale-down;
    object-position: 0;
    animation: move 30s linear alternate 0s infinite;
  }
}

@keyframes move {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-40%);
  }
}
</style>
